import PropTypes from 'prop-types';
import { Heading } from '@cof/plastic-components';
import { withText } from '../../../../text/textStore';

// @ts-expect-error TS7031: Binding element 'text' implicitly has an 'any' type.
const ExperimentHeadingText = ({ Text: text }) => (
    <Heading
        color="global.white"
        // @ts-expect-error TS2322: Type '"600"' is not assignable to type 'ResponsiveValue<keyof FontWeightKeys, DefaultTheme> | undefi
        fontWeight="600"
        data-qa-id="OB-landing-heading-text-b"
        fontSize={['headingLargeMobile', null, 'headingMediumDesktop']}
        paddingBottom={['0.8rem', null, '0.8rem']}
        textAlign="left"
        data-qm-allow
    >
        {text({ path: 'ObLandingHeading', params: { 'data-qm-allow': 'true' } })}
    </Heading>
);

ExperimentHeadingText.propTypes = {
    Text: PropTypes.func.isRequired
};

export default withText('OpenBankingLanding')(ExperimentHeadingText);
